import {notification} from 'antd';

export default function(err) {
    console.error('[VALIDATION ERROR', err);
    notification.error({
        message: 'Hatalı veya eksik bilgi girilmiş',
        description: 'Lütfen kontrol edip tekrar deneyin.'
    });
}
